import { observer } from 'mobx-react';
import React from 'react';
import { Table, TableCell, TableRow } from 'telia-front-react';
import { TranslationsContext } from '@teliaee/telia-translate';
import { replaceDotsAndFormatToCustomDecimalPlaceRoundingUp } from '../util/PriceUtil';
import { Prices } from './MeluCalculator';
import { getInfiniteCallsDevicePrice, getInternetDevicePrice } from './MeluDataUtil';

interface Props {
  internetDeviceCount: number;
  callsDeviceCount: number;
  prices?: Prices;
}

const MeluSelectedItems: React.FC<Props> = (props): JSX.Element => {
  const translate = React.useContext(TranslationsContext).translate;
  const internetAndCallsElements: JSX.Element[] = [];
  const onlyInternetElements: JSX.Element[] = [];

  for (let i = 1; i <= (props.internetDeviceCount || props.callsDeviceCount); i++) {
    const isCallDevice = props.internetDeviceCount ? props.callsDeviceCount >= i : props.callsDeviceCount === i;
    (isCallDevice ? internetAndCallsElements : onlyInternetElements).push(
      <TableRow key={`selected-melu-item-${i}`}>
        <TableCell className="text-small">{`${i}${translate('meluCalculator.calculatorCollapse.devices')}`}</TableCell>
        <TableCell className="text-right text-bold text-small">
          <>
            {replaceDotsAndFormatToCustomDecimalPlaceRoundingUp(
              isCallDevice ? getInfiniteCallsDevicePrice(props.prices) : getInternetDevicePrice(props.prices),
              3,
            )}
          </>
          <> {translate('meluCalculator.summaryTable.eurosPerMonth')}</>
        </TableCell>
      </TableRow>,
    );
  }

  return (
    <Table>
      {internetAndCallsElements.length > 0 && (
        <>
          <p className="h5 text-bold">{translate('meluCalculator.internetWithCalls.title')}</p>
          <tbody>{internetAndCallsElements}</tbody>
        </>
      )}
      {onlyInternetElements.length > 0 && (
        <>
          <p className="h5 text-bold">{translate('meluCalculator.onlyInternet.title')}</p>
          <tbody>{onlyInternetElements}</tbody>
        </>
      )}
    </Table>
  );
};

export default observer(MeluSelectedItems);
